import { differenceInDays, subDays, format } from "date-fns";

const baseCustomers = [
  {
    id: "1",
    fullName: "Carlos Pérez",
    phone: "70000001",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1985-03-15",
  },
  {
    id: "2",
    fullName: "María García",
    phone: "70000002",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1992-07-10",
  },
  {
    id: "3",
    fullName: "José Rodríguez",
    phone: "70000003",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1980-11-22",
  },
  {
    id: "4",
    fullName: "Ana Morales",
    phone: "70000004",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1996-01-08",
  },
  {
    id: "5",
    fullName: "Luis Martínez",
    phone: "70000005",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1979-09-05",
  },
  {
    id: "6",
    fullName: "Carmen López",
    phone: "70000006",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1991-12-01",
  },
  {
    id: "7",
    fullName: "Jorge Herrera",
    phone: "70000007",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1987-04-14",
  },
  {
    id: "8",
    fullName: "Laura Salazar",
    phone: "70000008",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1990-06-23",
  },
  {
    id: "9",
    fullName: "Diego Vargas",
    phone: "70000009",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1983-02-17",
  },
  {
    id: "10",
    fullName: "Paola Ríos",
    phone: "70000010",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1994-10-30",
  },
  {
    id: "11",
    fullName: "Ramiro Gutiérrez",
    phone: "70000011",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1982-05-06",
  },
  {
    id: "12",
    fullName: "Lucía Fernández",
    phone: "70000012",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1993-08-19",
  },
  {
    id: "13",
    fullName: "Eduardo Suárez",
    phone: "70000013",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1975-03-12",
  },
  {
    id: "14",
    fullName: "Gabriela Méndez",
    phone: "70000014",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1990-09-27",
  },
  {
    id: "15",
    fullName: "Ricardo Núñez",
    phone: "70000015",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1986-12-11",
  },
  {
    id: "16",
    fullName: "Mónica Aguilar",
    phone: "70000016",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1997-01-15",
  },
  {
    id: "17",
    fullName: "Sebastián Roca",
    phone: "70000017",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1981-06-05",
  },
  {
    id: "18",
    fullName: "Isabel Molina",
    phone: "70000018",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1989-03-29",
  },
  {
    id: "19",
    fullName: "Oscar Peña",
    phone: "70000019",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1984-08-13",
  },
  {
    id: "20",
    fullName: "Valeria Cruz",
    phone: "70000020",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1992-11-07",
  },
  {
    id: "21",
    fullName: "Andrés Lara",
    phone: "70000021",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1988-07-19",
  },
  {
    id: "22",
    fullName: "Claudia Torres",
    phone: "70000022",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1995-05-25",
  },
  {
    id: "23",
    fullName: "Fernando Paredes",
    phone: "70000023",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1978-10-01",
  },
  {
    id: "24",
    fullName: "Rosa Quispe",
    phone: "70000024",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1986-12-20",
  },
  {
    id: "25",
    fullName: "Nelson Álvarez",
    phone: "70000025",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1990-04-18",
  },
  {
    id: "26",
    fullName: "Daniela Rivero",
    phone: "70000026",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1993-06-02",
  },
  {
    id: "27",
    fullName: "Hugo Medina",
    phone: "70000027",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1982-09-14",
  },
  {
    id: "28",
    fullName: "Karen Vaca",
    phone: "70000028",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1987-02-28",
  },
  {
    id: "29",
    fullName: "Víctor Céspedes",
    phone: "70000029",
    countryCode: "591",
    gender: "Masculino",
    birthdate: "1977-01-03",
  },
  {
    id: "30",
    fullName: "Patricia Ramos",
    phone: "70000030",
    countryCode: "591",
    gender: "Femenino",
    birthdate: "1994-03-09",
  },
];
const generateRandomDate = () => {
  const daysAgo = Math.floor(Math.random() * 90); // últimos 90 días
  return subDays(new Date(), daysAgo); // Date object
};

const fakeCustomers = baseCustomers.map((c) => {
  const lastServiceDate = generateRandomDate();
  return {
    ...c,
    lastService: format(lastServiceDate, "yyyy-MM-dd"), // para DateField
    daysSinceLastService: differenceInDays(new Date(), lastServiceDate),
    totalServices: Math.floor(Math.random() * 15) + 1,
  };
});

export default fakeCustomers;
